import React, {
  useContext,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from "react";
import { IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { ConfigOptionsContext } from "../../../../../components/newPortal/NewPortalLayout";
import {
  appSubscriptionCheck,
  getAllFeaturesForSelectedRole,
  setAppSubscription,
  setClientConfigRef,
} from "../../../../../services/uiConfigService";
import { useSelector } from "react-redux";
import store from "../../../../../stateManagement/store";
import Loader from "../../../../../components/loading/Loader";
import { ImageIdToSVGMap } from "../../../../../components/newPortal/UiConfigOptions";

export interface otherConfigOptionsAttributes {
  id: string;
  sfg?: IconDefinition;
  icon?: string;
  displayTemplateTwo?: boolean;
  description: string;
  isSelected: boolean;
  isActive: boolean;
  hintImage: string;
  isMandatory: boolean;
  // role: string[];
  supportedAppTypes: string[];
  isDeveloped: boolean;
  action?: "added" | "removed";
  featureConfigName?: string;
  addTemplate?: boolean;
  additionalActivationConfigurations?: {
    domainType: string;
    domainValues: any[];
  }[];
  appType?: string;
  label?: string;
  subfeatures?:otherConfigOptionsAttributesFeature[]
}
export interface uiSchema{
  question:string;
  description?:string;
  config:string;
  validations?:any;
  displayType?:string;
  dependsOn?:Record<string,any>,
}
export interface Configurations{
  name:string,
  section?:string,
  domainType:string,
  uiSchema:uiSchema,
}

export interface otherConfigOptionsAttributesFeature {
  id: string;
  sfg?: IconDefinition;
  icon?: string;
  displayTemplateTwo?: boolean;
  isSelected: boolean;
  isActive: boolean;
  isVisible:boolean;
  hintImage: string;
  isMandatory: boolean;
  // role: string[];
  supportedAppTypes: string[];
  isDeveloped: boolean;
  action?: "added" | "removed";
  featureConfigName?: string;
  addTemplate?: boolean;
  domainMapping:Record<string,string[]>;
  appType?: string;
  label?: string;
  configuration:Configurations[]
   
}


const ConfigBottomBar: React.FC<{
  style?: React.CSSProperties;
  className?: string;
  handleStepIconClick?: (stepNumber: number) => void;
  displayMandatory: boolean;
}> = ({ style, className, handleStepIconClick, displayMandatory }) => {
  const context = useContext(ConfigOptionsContext);
  const [hasActiveChild, setHasActiveChild] = useState(false);
  const [activeChild, setActiveChild] = useState<string | undefined>(undefined);
  useEffect(() => {
    setHasActiveChild(!!localStorage.getItem("activeChild"));
  }, []);

  useEffect(() => {
    setOptional(
      uiConfigOptionsProp.find((options) => {
        return options.isActive === true;
      })?.id ?? null
    );
  }, []);

  function handleIconClick(iconId: string): void {
    setOptional(iconId);

    setUiConfigOptionsProp((prevState) =>
      prevState.map((opt) =>
        opt.id === iconId
          ? { ...opt, isActive: true }
          : { ...opt, isActive: false }
      )
    );

    if (handleStepIconClick) {
      handleStepIconClick(3);
    }
  }

  const { optional, setOptional, uiConfigOptionsProp, setUiConfigOptionsProp } =
    context!;
  const savedRole: any = useSelector(() => store.getState().roleState.role);
  const savedAppType: any = useSelector(
    () => store.getState().appTypeState.appType
  );
  const clientConfigRef = useRef<any[]>([]);
  const firstUpdate = useRef(true);
  const [isLoader, setIsloader] = useState<boolean>(false);
  const [standard, setStandard] = useState<string | undefined>(undefined);
  const [allFeaturesForSelectedRole, setAllFeaturesForSelectedRole] = useState<otherConfigOptionsAttributes[]>([]);
  
  const init = async () => {
    await setClientConfigRef(clientConfigRef,setIsloader);
    setAppSubscription(setStandard,clientConfigRef.current);
    updateSelectedAndDevelopedFeatures();
  }
  
  useEffect(() => {
    init();
  }, []);
  useLayoutEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
  });



  const updateSelectedAndDevelopedFeatures = () => {
    if(clientConfigRef.current.length < 1  || !savedRole || !savedAppType){
      return;
    }
    const allFeatures = getAllFeaturesForSelectedRole(savedRole,uiConfigOptionsProp,clientConfigRef,savedAppType).filter((option)=>option.isDeveloped && (option.isSelected || option.isMandatory) && appSubscriptionCheck(option,standard));
    setAllFeaturesForSelectedRole(allFeatures);

    // if >1 activechild or 0 active chile , only set firstChild as active if not set
    if(allFeatures.length > 1 && !allFeatures.find((option)=>option.isActive)){
      setOptional(allFeatures[0].id);
    }

  }
  useEffect(() => {
    updateSelectedAndDevelopedFeatures();
  }, [savedRole,savedAppType,standard]);
  return isLoader ? (
    <Loader />
  ) : (
    <div className="config-options" style={style}>
      {allFeaturesForSelectedRole
        .map((option,index) => {
          return (
            <div
              className={`${className ?? "config_option_container_temp"} ${
                (optional === option.id) || (activeChild === option.id) ? "active" : ""
              }`}
              key={option.id}
              onClick={() =>{
                debugger;
                handleIconClick(option.id)}}
              aria-label={`Select ${option.id}`}
            >
              <img
                src={ImageIdToSVGMap[option.icon ?? "default"]}
                alt={`${option.id} icon`}
              />
              <span>{option.label ?? option.id}</span>
            </div>
          );
        })}
    </div>
  );
};

export default ConfigBottomBar;

